import React, { useState, useEffect, useContext } from 'react'
import MeetingComponent from '../../components/MeetingCompontnt'
import MeetingForm from '../../components/MeetingForm'
import Table from '../../components/Table';
import { AuthContext } from '../../context/AuthContext';
import { api } from '../../api/axios';
import { onlyDateFormat } from '../../utils/dateHelper';
import { Eye, EyeOff, Trash, Pen, Video, VideoOff } from 'lucide-react';
import { toast } from 'react-toastify';
import Modal from '../../components/Modal';
import PaginationBar from '../../components/PaginationBar';

const PAGE_SIZE = 20;


const tableHeadingdata = ["#", "Title", "Description", "Status", "Date", "Time", "Action"]

export default function Meetings() {
    const { loading } = useContext(AuthContext);
    const [meetingsData, setMeetingsData] = useState([]);
    const [page, setPage] = useState(1);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editMeetingsData, setEditMeetingsData] = useState({
        id: null,
        title: '',
        description: '',
        date: '',
        time: '',
        status: '',
    })

    const [meetingStartTime, setMeetingStartTime] = useState(0)

    useEffect(() => {
        handelGetData();

    }, [loading])

    const handelGetData = async () => {
        try {
            const response = await api.get('/meetings');
            setMeetingsData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handelChangeVisibilityOffMeetings = async (id, isActive) => {
        try {
            const resposns = await api.patch(`/meetings/active/${id}`, { isActive: !isActive })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Meeting Visibility Changed Successfully")
            }
        } catch (error) {
            toast.error("Meeting Visibility Changed Error")
            console.log(error);
        }
    }

    const handelDeleteMeetings = async (id) => {
        if (!window.confirm('Delete this meeting? This cannot be undone.')) return;
        try {
            const resposns = await api.delete(`/meetings/${id}`)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Meeting Deleted Successfully")
            }

        } catch (error) {
            toast.error("Meeting Delete Error")
            console.log(error);
        }
    }

    const handelStartMeeting = async (id) => {
        try {
            const resposns = await api.patch(`/meetings/start/${id}`, { status: 'started' })

            if (resposns.status === 200) {
                setMeetingStartTime(Date.now())
                // console.log(Date.now());

                handelGetData();
                toast.success("Launching Meeting In New Tab")
            }

            setTimeout(() => {
                window.open("https://moderated.jitsi.net/67643bedacc14361bc4ec8490528f4f595845593a2694d5c8878deeb7f5fef76", "_blank")
            }, 2000)

        } catch (error) {
            toast.error("Meeting Start Error")
            console.log(error);
        }
    }

    const handelEndMeeting = async (id) => {
        try {
            const totalDeuration = Date.now() - meetingStartTime;
            const mettiingTotalDuration = await convertMilliseconds(totalDeuration)

            const resposns = await api.patch(`/meetings/end/${id}`, { status: 'completed', duration: mettiingTotalDuration })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Meeting Stop Successfully")
            }

        } catch (error) {
            toast.error("Meeting Stop Error")
            console.log(error);
        }
    }


    async function convertMilliseconds(ms) {
        const hours = Math.floor(ms / (1000 * 60 * 60)); // Convert milliseconds to hours
        const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60)); // Remaining milliseconds to minutes

        return `${hours} hour(s) and ${minutes} minute(s)`;
    }

    const handleOpenEditMeetingModal = async (item) => {
        setEditMeetingsData({
            id: item._id,
            title: item.title,
            description: item.description,
            date: item.date,
            time: item.time,
            status: item.status
        })
        setIsEditModalOpen(true)
    }

    const handlecloseEditMeetingModal = () => {
        setIsEditModalOpen(false)
    }

    const handleSubmitMeetingEditForm = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);

        try {
            const resposns = await api.patch(`/meetings/${editMeetingsData.id}`, data)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Meeting Updated Successfully")
                handlecloseEditMeetingModal();
            }

        } catch (error) {
            toast.error("Meeting Update Error")
            console.log(error);
        }
    }

    return (
        <>
            <MeetingComponent>
                <MeetingForm />
                <Table
                    tableHeadingdata={tableHeadingdata}>
                    {
                        meetingsData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((item, index) => (
                            <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={index}>
                                <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                    {(page - 1) * PAGE_SIZE + index + 1}
                                </th>
                                <td className="px-6 py-4 font-medium whitespace-wrap max-w-36">
                                    {item.title}
                                </td>
                                <td className="px-6 py-4 whitespace-wrap  max-w-40">
                                    {item.description}
                                </td>
                                <td className="px-6 py-4  w-1">
                                    {
                                        item.status === 'not-started'
                                            ?
                                            <span className='bg-red-300 rounded-2xl whitespace-nowrap px-2 py-1'>Not Started</span>
                                            :
                                            item.status === 'started'
                                                ?
                                                <span className='bg-yellow-200 rounded-2xl px-2 py-1 font-semibold'>Started</span>
                                                :
                                                <span className='bg-green-300 rounded-2xl px-2 py-1'>Completed</span>
                                    }
                                </td>
                                <td className="px-6 py-4 w-32 ">
                                    {onlyDateFormat(item.date)}
                                </td>
                                <td className="px-6 py-4  w-1">
                                    {item.time}
                                </td>
                                <td className="px-6 py-4 flex gap-3 justify-center w-40">
                                    <button
                                        onClick={() => {
                                            item.status === 'not-started' ?
                                                handelStartMeeting(item._id) :
                                                handelEndMeeting(item._id)
                                        }}
                                        disabled={item.status === 'completed'}
                                        title={item.status === 'not-started' ? 'Start Meeting' : item.status === 'started' ? 'Meeting Ongoing Click to Stop' : 'Meeting Completed'}
                                        className={`${item.status === 'not-started' ? 'text-green-400 dark:text-green-600 dark:hover:text-green-700 hover:text-green-700' : 'text-red-400 dark:text-red-600 dark:hover:text-red-700 hover:text-red-700'}font-medium`}>
                                        {item.status === 'not-started' ? <Video /> : <VideoOff />}
                                    </button>

                                    <button
                                        title={item.isActive ? 'Hide Meeting' : 'Show Meeting'}
                                        onClick={() => handelChangeVisibilityOffMeetings(item._id, item.isActive)}
                                        className="font-medium text-gray-400 dark:text-gray-400 dark:hover:text-gray-800 hover:text-gray-800">
                                        {item.isActive ? <Eye /> : <EyeOff />}
                                    </button>
                                    <button
                                        title='Delete Meeting'
                                        onClick={() => handelDeleteMeetings(item._id)}
                                        className="font-medium text-red-300 dark:text-red-300 dark:hover:text-red-600 hover:text-red-600">
                                        <Trash />
                                    </button>
                                    <button
                                        title='Edit Meeting'
                                        onClick={() => handleOpenEditMeetingModal(item)}
                                        className="font-medium text-green-300 dark:text-greenblue-300 dark:hover:text-green-600 hover:text-green-600">
                                        <Pen />
                                    </button>
                                </td>
                            </tr>
                        ))
                    }
                </Table>

                <div className="mt-4">
                    <PaginationBar
                        totalItems={meetingsData.length}
                        page={page}
                        pageSize={PAGE_SIZE}
                        onChange={setPage}
                    />
                </div>

                {
                    isEditModalOpen && <Modal
                        title={'Edit Meeting'}
                        closeModal={handlecloseEditMeetingModal}
                    >
                        <form onSubmit={handleSubmitMeetingEditForm} className='grid grid-cols-6 gap-x-4 gap-y-6 w-[50rem]'>
                            <div className="col-span-4">
                                <label htmlFor="title" className="block text-sm/6 font-medium text-gray-900">
                                    Title <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="title"
                                        name="title"
                                        type="text"
                                        defaultValue={editMeetingsData.title}
                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="date" className="block text-sm/6 font-medium text-gray-900">
                                    Date <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="date"
                                        name="date"
                                        type="date"
                                        defaultValue={editMeetingsData.date}
                                        required={true}
                                        disabled={editMeetingsData.status === "completed"}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-1">
                                <label htmlFor="time" className="block text-sm/6 font-medium text-gray-900">
                                    Time <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="time"
                                        name="time"
                                        type="time"
                                        defaultValue={editMeetingsData.time}
                                        required={true}
                                        disabled={editMeetingsData.status === "completed"}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-6">
                                <label htmlFor="description" className="block text-sm/6 font-medium text-gray-900">
                                    Description <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <textarea
                                        id="description"
                                        name="description"
                                        type="text"
                                        defaultValue={editMeetingsData.description}
                                        required={true}
                                        rows={4}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    ></textarea>
                                </div>
                            </div>
                            <div className="col-span-6 flex justify-center">
                                <button
                                    type="submit"
                                    className="rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                >
                                    Update Meeting
                                </button>
                            </div>
                        </form>
                    </Modal>
                }
            </MeetingComponent>
        </>
    )
}
